import MapView from "@arcgis/core/views/MapView.js"
import Map from '@arcgis/core/Map.js'
import { initLocatorLayer } from './layers/LocatorLayer'
import { initSearchResultsLayer } from './layers/SearchResultsLayer'
import { initSelectionLayer } from './layers/SelectionLayer'
import { initLegendLayer } from "./layers/LegendLayer"
import { initImageryLayers } from "./layers/ImageryLayers"
import { initComplexParcelDetailsLayer } from "./layers/ComplexParcelDetailsLayer"



let map: __esri.Map | null = null
let view: __esri.MapView | null = null

export const getMap = () => map
export const getView = () => view

export const init = (containerId: string) => {
  map = new Map({
    basemap: 'streets'
  })

  view = new MapView({
    map,
    container: containerId,
    center: [-78.938501, 33.933995], // Longitude, latitude of horry county
    zoom: 9, // Zoom level to see most of the county
  })

  view.ui.move("zoom", "bottom-right")

  initImageryLayers(map, view)
  initLegendLayer(map, view)
  initLocatorLayer(map, view)
  initSearchResultsLayer(map, view)
  initSelectionLayer(map, view)
  initComplexParcelDetailsLayer(map, view)
}


export const zoomTo = (geometry: __esri.Geometry, zoomLevel: number | undefined) => {
  if (view) {
    view.when(() => {
      let zoomPromise = zoomLevel 
        ?  view?.goTo({ target: geometry, zoom: zoomLevel })
        : view?.goTo({
            target: geometry,
            extent: geometry.extent.expand(1.5),
          })
      zoomPromise?.catch((error) => {
        if (error.name !== "AbortError") {
          console.error(error)
        }
      })
    })
  } else {
    setTimeout(() => zoomTo(geometry, zoomLevel), 100)
  }
}